import { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { gsap, Elastic, Power4 } from 'gsap'

import style from './header.module.css'

const Collaboration = (props) => {
  const parentEle = useRef()
  const [msftTl] = useState(gsap.timeline({ paused: true }))
  const [googTl] = useState(gsap.timeline({ paused: true }))

  useEffect(() => {
    setTimeout(() => {
      msftTl
        .set('.excel,.word,.powerpoint,.teams,.outlook', {
          x: 0,
          y: 0,
          opacity: 0,
          scale: 0.85,
          position: 'absolute',
          zIndex: 2,
        })
        .to(`.${style.msfticons}`, { opacity: 1 }, 'msftstart')
        .to(
          '.excel',
          { rotation: -5, x: -10, y: -5, opacity: 1, ease: Power4.easeOut() },
          'msftstart'
        )
        .to(
          '.word',
          { rotation: 3, x: 28, y: -20, opacity: 1, ease: Power4.easeOut() },
          'msftstart'
        )
        .to(
          '.powerpoint',
          { rotation: -6, x: -32, y: 18, opacity: 1, ease: Power4.easeOut() },
          'msftstart'
        )
        .to(
          '.outlook',
          { rotation: 1, x: 172, y: -28, opacity: 1, ease: Power4.easeOut() },
          'msftstart'
        )
        .to(
          '.teams',
          { x: 235, y: -18, opacity: 1, rotation: 8, ease: Power4.easeOut() },
          'msftstart'
        )

      googTl
        .set('.gtools,.gcal,.gchat,.gdrive,.gmail', {
          x: 50,
          y: 50,
          opacity: 0,
          position: 'absolute',
          zIndex: 2,
        })
        .to(`.${style.googicons}`, { opacity: 1 }, 'googstart')
        .to(
          '.gtools',
          { rotation: -5, y: -5, x: -22, opacity: 1, ease: Power4.easeOut() },
          'googstart'
        )
        .to(
          '.gcal',
          { rotation: -10, y: 80, x: -5, opacity: 1, ease: Power4.easeOut() },
          'googstart'
        )
        .to(
          '.gchat',
          { rotation: 4, x: 105, y: -12, opacity: 1, ease: Power4.easeOut() },
          'googstart'
        )
        .to(
          '.gdrive',
          { rotation: 6, x: 170, y: -15, opacity: 1, ease: Power4.easeOut() },
          'googstart'
        )
        .to(
          '.gmail',
          { rotation: 8, x: 280, y: -2, opacity: 1, ease: Power4.easeOut() },
          'googstart'
        )
      gsap.fromTo(
        `.${style.navboxms}`,
        { y: 500, x: 10, opacity: 0 },
        { y: 230, duration: 1.5, opacity: 1, ease: Elastic.easeOut.config(1, 1) }
      )
      gsap.fromTo(
        `.${style.gcptext}`,
        { opacity: 0, y: 150, x: -150 },
        { y: 5, duration: 1.25, opacity: 1, x: 0, ease: Elastic.easeOut.config(1, 1.5) }
      )
      gsap.fromTo(
        `.${style.o365text}`,
        { opacity: 0, y: 150, x: 150 },
        { y: 5, duration: 1.25, opacity: 1, x: 0, ease: Elastic.easeOut.config(1, 1.5) }
      )
      gsap.fromTo(
        `.${style.collabtitle}`,
        { x: -500, opacity: 0, y: 0 },
        { x: 0, duration: 1.5, opacity: 1, y: 10, ease: Elastic.easeOut.config(1, 1) }
      )
      gsap.fromTo(
        `.gcptab`,
        { x: -500, opacity: 0, y: -100 },
        { x: 0, duration: 1, opacity: 1, y: 20, ease: Elastic.easeOut.config(1, 1.2) }
      )
      gsap.fromTo(
        `.o365tab`,
        { x: 500, opacity: 0, y: -100 },
        { x: 0, duration: 1, y: 20, opacity: 1, ease: Elastic.easeOut.config(1, 1.2) }
      )
      gsap.fromTo(
        `.${style.msbox}`,
        { y: 200, opacity: 0, x: -20 },
        {
          y: 45,
          opacity: 1,
          x: 50,
          duration: 1.5,
          ease: Elastic.easeOut.config(1, 1),
          stagger: 0.2,
        }
      )
    }, 20)
  }, [])

  const msftAnim = () => {
    msftTl.play()
  }

  const msftAnimOut = () => {
    msftTl.reverse()
  }

  const googAnim = () => {
    googTl.play()
  }

  const googAnimOut = () => {
    googTl.reverse()
  }

  return (
    <div ref={parentEle} className={style.collabwrap}>
      <div className={style.navboxms} />
      <div className={style.collabtitle}>COLLABORATION SOLUTIONS</div>
      <div className={style.collablinks}>
        <Link
          aria-label="Observian Google Workspace"
          to="/google-workspace"
          style={{ textDecoration: 'none' }}
        >
          <div className={style.googicons}>
            <img src="/images/google/gcal.png" className="gcal" alt="Google Calendar" />
            <img src="/images/google/gchat.png" className="gchat" alt="microsoft word" />
            <img src="/images/google/gdrive.png" className="gdrive" alt="Google Drive" />
            <img src="/images/google/gmail.png" className="gmail" alt="Google Mail" />
            <img src="/images/google/gtools.png" className="gtools" alt="Google Tools" />
          </div>
          <div className={style.collabcol}>
            <svg
              viewBox="0 0 330 132"
              className="gcptab"
              onMouseEnter={googAnim}
              onMouseLeave={googAnimOut}
            >
              <defs>
                <path
                  id="bgwork"
                  d="M31.6924989 0L0 20.9190795 14.7985255 68.116076 44.9370001 90.7682817 267.64561 92.1212869 292.798525 43.9424069 271.718163 0.417478637z"
                />
                <filter
                  x="-12.0%"
                  y="-27.1%"
                  width="123.9%"
                  height="176.0%"
                  filterUnits="objectBoundingBox"
                  id="agwork"
                >
                  <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                  <feGaussianBlur
                    stdDeviation={10}
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                  />
                  <feColorMatrix
                    values="0 0 0 0 0.925490196 0 0 0 0 0.243137255 0 0 0 0 0.168627451 0 0 0 0.217466128 0"
                    in="shadowBlurOuter1"
                  />
                </filter>
                <linearGradient
                  x1="44.1644185%"
                  y1="84.9243045%"
                  x2="55.8897987%"
                  y2="16.3295925%"
                  id="cgwork"
                >
                  <stop stopColor="#EC3E2B" offset="0%" />
                  <stop stopColor="#F94E3C" offset="100%" />
                </linearGradient>
                <filter
                  x="-77.8%"
                  y="-30.7%"
                  width="255.5%"
                  height="161.3%"
                  filterUnits="objectBoundingBox"
                  id="dgwork"
                >
                  <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
                </filter>
              </defs>
              <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g transform="translate(18 10)">
                  <use fill="#000" filter="url(#agwork)" xlinkHref="#bgwork" />
                  <use fill="#FFF" xlinkHref="#bgwork" />
                  <path
                    fill="url(#cgwork)"
                    d="M235.782904 71.3399402L245.293168 43.3276875 231.393211 22.4183538 250.679905 44.9672233z"
                  />
                  <path
                    fill="#EC3F2B"
                    opacity={0.15}
                    d="M182.130525 0.651595825L208.081686 46.5011011 192.182431 92 267.64561 92.1212869 292.798525 43.9424069 271.718163 0.417478637z"
                  />
                  <path
                    fill="url(#cgwork)"
                    filter="url(#dgwork)"
                    d="M231.782904 75.3399402L241.293168 47.3276875 227.393211 26.4183538 246.679905 48.9672233z"
                  />
                </g>
                <g fillRule="nonzero">
                  <g transform="translate(53 46) translate(63.4 1.4)" fill="#5F6368">
                    <path d="M14.78 0.03L16.546 0.03 13.032 13.204 11.302 13.204 8.468 4.52 8.394 4.52 5.56 13.204 3.83 13.204 0.17 0.03 1.936 0.03 4.714 10.39 4.788 10.39 7.64 1.798 9.222 1.798 12.074 10.39 12.148 10.39z" />
                    <path d="M16.386 8.696c0-1.386.436-2.532 1.306-3.44.884-.908 1.994-1.362 3.33-1.362s2.442.454 3.312 1.362c.884.908 1.324 2.054 1.324 3.44 0 1.398-.442 2.546-1.324 3.44-.872.908-1.976 1.362-3.312 1.362-1.338 0-2.448-.454-3.33-1.362-.87-.906-1.306-2.054-1.306-3.44zm1.692 0c0 .97.282 1.754.846 2.356.564.602 1.264.902 2.098.902.834 0 1.534-.3 2.098-.902.564-.6.846-1.386.846-2.356 0-.956-.282-1.736-.846-2.336-.576-.614-1.276-.92-2.098-.92-.822 0-1.522.306-2.098.92-.564.6-.846 1.38-.846 2.336zM28.554 13.204h-1.692V4.188h1.62V5.66h.074c.172-.478.524-.886 1.058-1.224.534-.338 1.058-.506 1.574-.506.49 0 .908.074 1.252.22l-.516 1.638c-.208-.086-.54-.128-.994-.128-.638 0-1.194.258-1.666.772a2.587 2.587 0 00-.708 1.804v4.968h-.002z" />
                    <path d="M41.15 13.204L39.108 13.204 36.292 8.954 34.912 10.316 34.912 13.204 33.22 13.204 33.22 0.03 34.912 0.03 34.912 8.144 38.812 4.188 40.984 4.188 40.984 4.262 37.47 7.758 41.15 13.13z" />
                    <path d="M48.476 10.702c0 .786-.344 1.448-1.03 1.988-.688.54-1.552.81-2.594.81-.908 0-1.706-.236-2.392-.708a3.891 3.891 0 01-1.472-1.868l1.508-.644c.22.54.542.96.966 1.26.424.3.886.45 1.39.45.54 0 .99-.116 1.352-.35.362-.232.542-.508.542-.828 0-.576-.442-1-1.324-1.27l-1.546-.386c-1.754-.442-2.632-1.288-2.632-2.54 0-.822.334-1.482 1.002-1.978.668-.496 1.524-.746 2.566-.746.798 0 1.518.19 2.162.57.644.38 1.094.89 1.352 1.528l-1.508.626a1.892 1.892 0 00-.838-.892 2.63 2.63 0 00-1.298-.322c-.442 0-.838.11-1.186.332-.348.222-.524.49-.524.81 0 .516.484.884 1.454 1.104l1.362.35c1.792.44 2.688 1.342 2.688 2.704zM54.354 13.498a3.89 3.89 0 01-1.812-.424c-.546-.282-.966-.656-1.26-1.122h-.074l.074 1.252v3.974H49.59V4.188h1.62V5.44h.074c.294-.466.714-.84 1.26-1.122a3.89 3.89 0 011.812-.424c1.19 0 2.196.466 3.018 1.398.846.944 1.27 2.08 1.27 3.404 0 1.338-.424 2.472-1.27 3.404-.824.932-1.83 1.398-3.02 1.398zm-.276-1.544c.81 0 1.49-.306 2.042-.92.552-.6.828-1.38.828-2.336 0-.944-.276-1.724-.828-2.336-.552-.614-1.232-.92-2.042-.92-.822 0-1.508.306-2.06.92-.54.614-.81 1.392-.81 2.336 0 .956.27 1.742.81 2.356.55.598 1.238.9 2.06.9zM63.278 3.894c1.252 0 2.238.334 2.962 1.002.724.668 1.086 1.586 1.086 2.75v5.556h-1.62V11.95h-.074c-.7 1.03-1.632 1.546-2.796 1.546-.994 0-1.824-.294-2.494-.884-.668-.588-1.002-1.324-1.002-2.208 0-.932.352-1.674 1.058-2.226.706-.552 1.646-.828 2.824-.828 1.006 0 1.834.184 2.484.552v-.386c0-.588-.234-1.088-.7-1.5a2.402 2.402 0 00-1.638-.616c-.944 0-1.692.398-2.244 1.196l-1.49-.938c.822-1.176 2.036-1.764 3.644-1.764zm-2.19 6.55c0 .442.186.81.562 1.104.374.294.812.442 1.316.442.712 0 1.346-.264 1.904-.792.558-.528.838-1.146.838-1.858-.528-.416-1.264-.626-2.208-.626-.688 0-1.26.166-1.72.496-.462.332-.692.744-.692 1.234zM73.064 13.498c-1.338 0-2.448-.454-3.33-1.362-.872-.932-1.306-2.08-1.306-3.44 0-1.386.436-2.532 1.306-3.44.884-.908 1.994-1.362 3.33-1.362.92 0 1.724.23 2.41.69.686.46 1.202 1.094 1.546 1.904l-1.546.644c-.478-1.128-1.318-1.692-2.52-1.692-.772 0-1.442.312-2.006.938-.552.626-.828 1.398-.828 2.318 0 .92.276 1.692.828 2.318.564.626 1.232.938 2.006.938 1.238 0 2.11-.564 2.612-1.692l1.508.644a4.047 4.047 0 01-1.554 1.904c-.704.46-1.524.69-2.456.69zM82.174 13.498c-1.324 0-2.416-.454-3.276-1.362-.858-.908-1.288-2.054-1.288-3.44 0-1.374.416-2.518 1.252-3.432.834-.914 1.902-1.37 3.202-1.37 1.336 0 2.402.432 3.192 1.298.792.864 1.186 2.076 1.186 3.634l-.018.184H79.34c.024.884.318 1.594.884 2.134.564.54 1.238.81 2.024.81 1.08 0 1.926-.54 2.54-1.62l1.508.736a4.483 4.483 0 01-1.684 1.784c-.718.428-1.53.644-2.438.644zM79.47 7.61h5.17a2.245 2.245 0 00-.764-1.554c-.46-.41-1.076-.616-1.85-.616-.638 0-1.186.196-1.646.588-.46.394-.764.92-.91 1.582z" />
                  </g>
                  <g transform="translate(53 46)">
                    <path
                      d="M7.552 14.896C3.448 14.896 0 11.552 0 7.448 0 3.344 3.448 0 7.552 0c2.27 0 3.884.89 5.1 2.052l-1.434 1.434c-.872-.818-2.052-1.454-3.666-1.454-2.994 0-5.336 2.416-5.336 5.414 0 2.998 2.342 5.412 5.336 5.412 1.942 0 3.05-.78 3.758-1.49.58-.582.962-1.416 1.108-2.562h-4.92v-2.03h6.896c.072.364.108.8.108 1.272 0 1.526-.418 3.416-1.76 4.76-1.306 1.36-2.976 2.088-5.19 2.088z"
                      fill="#4285F4"
                    />
                    <path
                      d="M24.832 10.1c0 2.762-2.158 4.796-4.804 4.796-2.646 0-4.806-2.036-4.806-4.796 0-2.78 2.158-4.796 4.804-4.796 2.646 0 4.806 2.016 4.806 4.796zm-2.104 0c0-1.726-1.252-2.906-2.702-2.906s-2.702 1.18-2.702 2.906c0 1.708 1.252 2.906 2.702 2.906 1.452 0 2.702-1.2 2.702-2.906z"
                      fill="#EA4335"
                    />
                    <path
                      d="M35.29 10.1c0 2.762-2.158 4.796-4.804 4.796-2.646 0-4.806-2.036-4.806-4.796 0-2.78 2.158-4.796 4.804-4.796 2.646 0 4.806 2.016 4.806 4.796zm-2.104 0c0-1.726-1.252-2.906-2.702-2.906s-2.702 1.18-2.702 2.906c0 1.708 1.252 2.906 2.702 2.906s2.702-1.2 2.702-2.906z"
                      fill="#FBBC04"
                    />
                    <path
                      d="M45.294 5.594v8.61c0 3.542-2.088 4.996-4.556 4.996-2.324 0-3.722-1.562-4.248-2.834l1.834-.762c.326.782 1.126 1.708 2.414 1.708 1.58 0 2.56-.98 2.56-2.816v-.69h-.072c-.472.582-1.38 1.09-2.524 1.09-2.396 0-4.592-2.088-4.592-4.778 0-2.706 2.196-4.814 4.592-4.814 1.144 0 2.052.508 2.524 1.072h.072v-.782h1.996zm-1.852 4.524c0-1.69-1.126-2.924-2.56-2.924-1.452 0-2.668 1.236-2.668 2.924 0 1.672 1.216 2.888 2.668 2.888 1.434 0 2.56-1.218 2.56-2.888z"
                      fill="#4285F4"
                    />
                    <path
                      fill="#34A853"
                      d="M48.914 0.508L48.914 14.604 46.808 14.604 46.808 0.508z"
                    />
                    <path
                      d="M57.076 11.68l1.634 1.09c-.526.782-1.798 2.126-3.994 2.126-2.722 0-4.756-2.108-4.756-4.796 0-2.852 2.052-4.796 4.52-4.796 2.486 0 3.702 1.98 4.102 3.052l.218.544-6.408 2.652c.49.962 1.252 1.454 2.324 1.454 1.07 0 1.816-.526 2.36-1.326zm-5.028-1.726l4.284-1.78c-.236-.6-.944-1.018-1.778-1.018-1.072 0-2.56.946-2.506 2.798z"
                      fill="#EA4335"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <div className={style.gcptext}>
              Observian is a Premier Google Partner and Google Workspace reseller. We provide
              customers with free training, migrations and support from Google Workspace experts.
            </div>
          </div>
        </Link>
        <Link aria-label="Observian Office 365" to="/office365" style={{ textDecoration: 'none' }}>
          <div className={style.msfticons}>
            <img
              src="/images/office365/logos/msftexcel.png"
              className="excel"
              alt="microsoft excel"
            />
            <img src="/images/office365/logos/msftword.png" className="word" alt="microsoft word" />
            <img
              src="/images/office365/logos/msftoulook.png"
              className="outlook"
              alt="microsoft outlook"
            />
            <img
              src="/images/office365/logos/msftpp.png"
              className="powerpoint"
              alt="microsoft powerpoint"
            />
            <img
              src="/images/office365/logos/msftteams.png"
              className="teams"
              alt="microsoft teams"
            />
          </div>
          <div className={style.collabcol}>
            <svg
              viewBox="0 0 318 130"
              className="o365tab"
              onMouseEnter={msftAnim}
              onMouseLeave={msftAnimOut}
            >
              <defs>
                <path
                  id="bo365link"
                  d="M26.2403005 -4.54747351e-13L-9.09494702e-13 48.116076 14.0229087 87.7682817 182.407657 90.6166722 251.281965 88.672657 281 43.9424069 249.849012 8.73989256z"
                />
                <filter
                  x="-12.5%"
                  y="-27.6%"
                  width="124.9%"
                  height="177.2%"
                  filterUnits="objectBoundingBox"
                  id="ao365link"
                >
                  <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                  <feGaussianBlur
                    stdDeviation={10}
                    in="shadowOffsetOuter1"
                    result="shadowBlurOuter1"
                  />
                  <feColorMatrix
                    values="0 0 0 0 0.921568627 0 0 0 0 0.235294118 0 0 0 0 0 0 0 0 0.25904174 0"
                    in="shadowBlurOuter1"
                  />
                </filter>
                <filter
                  x="-31.5%"
                  y="-16.2%"
                  width="162.9%"
                  height="132.3%"
                  filterUnits="objectBoundingBox"
                  id="co365link"
                >
                  <feGaussianBlur stdDeviation={2} in="SourceGraphic" />
                </filter>
              </defs>
              <g
                transform="translate(19 10)"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
              >
                <use fill="#000" filter="url(#ao365link)" xlinkHref="#bo365link" />
                <use fill="#FFF" xlinkHref="#bo365link" />
                <path
                  d="M168.988 4.704L184.688 48l-15.7 42.43c-5.187.273-.225.273 14.887 0s37.617-.921 67.515-1.944L281 43.756 249.962 8.553l-80.974-3.849z"
                  fill="#EB3C00"
                  opacity={0.15}
                />
                <path
                  fill="#EB3C00"
                  opacity={0.43796503}
                  filter="url(#c)"
                  d="M208.212891 67.8261719L220.899957 46.9093337 208.212891 30.7167969 227.286695 47.5488694z"
                />
                <path
                  fill="#EB3C00"
                  d="M211.212891 65.8261719L223.899957 44.9093337 211.212891 28.7167969 230.286695 45.5488694z"
                />
                <path
                  d="M59 53.265v-16.78L73.793 31l8.04 2.581V56.17l-8.04 2.431L59 53.264l14.793 1.787V35.518l-9.648 2.258v13.23L59 53.265zm38.588.117c-2.328 0-4.193-.77-5.594-2.31-1.401-1.54-2.102-3.542-2.102-6.01 0-2.65.714-4.764 2.142-6.342 1.428-1.578 3.37-2.367 5.83-2.367 2.267 0 4.093.766 5.479 2.298 1.386 1.532 2.079 3.535 2.079 6.01 0 2.689-.71 4.814-2.13 6.377-1.42 1.563-3.322 2.344-5.704 2.344zm.138-15.283c-1.726 0-3.127.625-4.203 1.873-1.077 1.249-1.615 2.888-1.615 4.918 0 2.03.525 3.664 1.575 4.901 1.05 1.237 2.418 1.856 4.105 1.856 1.802 0 3.222-.59 4.26-1.77 1.039-1.18 1.558-2.83 1.558-4.952 0-2.176-.504-3.857-1.512-5.045-1.008-1.187-2.397-1.78-4.168-1.78zm14.539-2.667c-1.061 0-1.943.363-2.653 1.08-.71.716-1.066 1.69-1.066 2.924v1.905h-2v1.614h2v10.154h1.87V42.955h4.572v10.154h1.87V42.955h2.743V41.34h-2.743v-1.815c0-1.662.656-2.49 1.97-2.49.465 0 .879.095 1.246.302v-1.694c-.336-.138-.785-.212-1.357-.212-1.061 0-1.953.363-2.663 1.08-.71.716-1.066 1.69-1.066 2.923v1.906h-4.572v-1.815c0-1.662.656-2.49 1.97-2.49.465 0 .88.095 1.246.302v-1.694c-.336-.138-.795-.212-1.367-.212zm10.068 2.918c-.336 0-.623-.114-.86-.344a1.165 1.165 0 01-.354-.874c0-.352.118-.645.355-.879.236-.233.523-.35.859-.35.343 0 .635.117.876.35.24.234.36.527.36.88 0 .337-.12.624-.36.861a1.2 1.2 0 01-.876.356zm.916 14.755h-1.878V41.338h1.878v11.767zm10.67-.54c-.9.543-1.97.815-3.207.815-1.672 0-3.021-.546-4.048-1.637-1.027-1.092-1.54-2.507-1.54-4.246 0-1.938.553-3.495 1.66-4.671 1.107-1.176 2.585-1.764 4.432-1.764 1.03 0 1.94.192 2.726.575v1.93c-.87-.613-1.802-.92-2.794-.92-1.2 0-2.182.432-2.95 1.294-.767.861-1.15 1.993-1.15 3.395 0 1.38.36 2.467 1.082 3.264.721.796 1.689 1.195 2.903 1.195 1.023 0 1.985-.341 2.886-1.023v1.792zm11.481-4.872h-8.28c.03 1.31.382 2.321 1.054 3.034.671.712 1.595 1.068 2.771 1.068 1.32 0 2.535-.436 3.642-1.31v1.77c-1.03.75-2.394 1.126-4.089 1.126-1.656 0-2.958-.534-3.905-1.603-.947-1.069-1.42-2.572-1.42-4.51 0-1.831.517-3.323 1.552-4.476 1.034-1.153 2.319-1.729 3.854-1.729 1.534 0 2.721.498 3.561 1.494.84.996 1.26 2.378 1.26 4.148v.988zm-1.924-1.597c-.008-1.088-.27-1.934-.785-2.54-.515-.605-1.23-.907-2.147-.907a3.03 3.03 0 00-2.256.953c-.618.636-1 1.467-1.145 2.494h6.333z"
                  fill="#EB3C00"
                  fillRule="nonzero"
                />
              </g>
            </svg>
            <div className={style.o365text}>
              As a Microsoft Gold Partner, Observian offers free support, migrations and licensing
              discounts on Microsoft Office 365 solutions.
            </div>
          </div>
        </Link>
      </div>

      <div className={style.mscontent}>
        {/* <div className={style.msheader}>
          We offer a variety of customizable Managed Service offerings to help you focus on what you
          do best.
        </div> */}
        <div className={style.contentbelow}>
          <div className={style.msitems}>
            <Link to="/managed-productivity" className={style.nounderline}>
              <div className={style.msbox}>
                <img
                  src="/images/managedprod.png"
                  alt="Observian Managed Productivity"
                  className={style.awspic}
                />
                <div className={clsx(style.mscontent, style.awscontent)}>
                  <svg viewBox="0 0 931 55">
                    <defs>
                      <linearGradient
                        x1="14.8581364%"
                        y1="50.7535005%"
                        x2="85.3734672%"
                        y2="49.2402223%"
                        id="collabaprod"
                      >
                        <stop stopColor="#1D8DBA" offset="0%" />
                        <stop stopColor="#03ECAE" offset="100%" />
                      </linearGradient>
                    </defs>
                    <g fillRule="nonzero" stroke="none" strokeWidth={1} fill="none">
                      <path
                        d="M407.55 53.475v-16.5h3.975c11.475 0 19.125-7.575 19.125-18.15 0-10.35-7.2-17.85-19.35-17.85h-22.05v52.5h18.3zm1.725-30.3h-1.725v-7.95h1.875c2.25 0 3.825 1.65 3.825 3.975 0 2.55-1.875 3.975-3.975 3.975zm42.6 30.3v-16.95l7.425 16.95h20.625l-12-21.975c4.425-2.475 8.325-7.425 8.325-13.5 0-9.525-7.2-17.025-19.5-17.025h-23.325v52.5h18.45zm2.25-30.9h-2.25v-7.35h2.25c2.4 0 3.75 1.875 3.75 3.675 0 1.8-1.35 3.675-3.75 3.675zM506.7 54.45c17.925 0 29.025-11.925 29.025-27.3C535.725 12 524.625 0 506.7 0c-17.925 0-29.025 12-29.025 27.15 0 15.375 11.1 27.3 29.025 27.3zm0-15.675c-5.925 0-9.15-4.8-9.15-11.625 0-6.6 3.225-11.475 9.15-11.475 5.85 0 9.15 4.875 9.15 11.475 0 6.825-3.3 11.625-9.15 11.625zm50.625 14.7c17.625 0 29.325-10.125 29.325-26.325 0-16.425-11.85-26.175-29.325-26.175h-18.75v52.5h18.75zm.825-15h-1.125v-22.5h1.125c5.475 0 9.075 3.525 9.075 11.175s-3.6 11.325-9.075 11.325zm55.5 15.975c15.75 0 24.3-8.925 24.3-21.6V.975H618.9V33.3c0 3.6-2.1 5.475-5.25 5.475-3.075 0-5.1-1.875-5.1-5.475V.975H589.5V32.85c0 12.675 8.475 21.6 24.15 21.6zm55.425 0c8.25 0 13.575-2.1 17.925-5.175L681.375 34.2c-2.4 2.175-5.85 4.125-10.2 4.125-5.85 0-10.5-4.35-10.5-11.175 0-6.525 4.5-11.025 10.5-11.025 4.05 0 7.275 1.575 9.825 4.05l5.7-15C682.5 2.25 677.025 0 669.075 0c-17.1 0-28.275 12.075-28.275 27.15 0 16.35 11.85 27.3 28.275 27.3zm49.65-.975V15.75h10.35V.975H689.4V15.75h10.275v37.725h19.05zm32.7 0V.975h-19.05v52.5h19.05zm41.025 0L811.5.975h-20.025l-8.325 30.75-8.325-30.75H754.2l19.05 52.5h19.2zm40.875 0V.975h-19.05v52.5h19.05zm32.7 0V15.75h10.35V.975H836.7V15.75h10.275v37.725h19.05zm48.6 0V31.05L931.05.975h-20.325l-5.25 14.925-5.25-14.925H879.15l16.425 30.075v22.425h19.05z"
                        fill="#04E6AE"
                      />
                      <path
                        d="M257.175.75c-8.096 0-14.88 2.817-19.688 7.434-4.985 4.786-7.837 11.5-7.837 18.966 0 7.71 2.727 14.475 7.693 19.244 4.766 4.578 11.584 7.306 19.982 7.306 12.91 0 20.24-4.372 24.75-8.219V23.25h-21.45v11.175h5.925v3.171c-.812.618-3.124 1.779-7.2 1.779-3.44 0-6.255-1.246-8.223-3.382-1.973-2.14-3.102-5.193-3.102-8.843 0-3.45 1.192-6.36 3.158-8.425 2.013-2.114 4.845-3.35 8.092-3.35 4.11 0 7.063 1.43 9.615 3.537l9.596-10.345c-4.2-4.12-10.769-7.817-21.311-7.817zm-233.896.975H.75v51h17.025V21.936L24.29 48.75h15.62l6.515-26.814v30.789H63.45v-51H40.92L32.1 33.64 23.28 1.725zm79.912 0l17.631 51H102.94l-2.325-8.025H87.186l-2.325 8.025H67.878l17.631-51h17.682zm-9.282 16.74L89.913 32.85h7.892L93.91 18.465zm49.386-16.74H125.25v51h17.325V25.388l12.63 27.337h18.045v-51h-17.325v27.337l-12.63-27.337zm69.696 0l17.631 51H212.74l-2.325-8.025h-13.428l-2.325 8.025h-16.983l17.631-51h17.682zm-9.282 16.74l-3.996 14.385h7.892l-3.896-14.385zM318.6 1.725h-31.275v51H318.6V39.45h-13.8v-6.225h12.3V20.85h-12.3V15h13.8V1.725zm24 0c8.637 0 15.879 2.418 20.914 6.913 4.878 4.353 7.661 10.65 7.661 18.512 0 7.812-2.79 14.178-7.714 18.598-5.011 4.5-12.211 6.977-20.861 6.977h0-18v-51zm.825 13.5h-1.875v24h1.875c3.068 0 5.58-1.08 7.308-3.235 1.586-1.98 2.517-4.905 2.517-8.84 0-3.926-.927-6.81-2.505-8.753-1.727-2.126-4.243-3.172-7.32-3.172z"
                        stroke="url(#collabaprod)"
                        strokeWidth={1.5}
                        fillOpacity={0.55}
                        fill="url(#collabaprod)"
                      />
                    </g>
                  </svg>
                  <div className={style.msDesc}>
                    Data retention &amp; security for saas applications. <br />
                    Starting at $7 per user monthly.
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

Collaboration.propTypes = {
  parentw: PropTypes.string.isRequired,
  parenth: PropTypes.string.isRequired,
}

export default Collaboration
